import { Box, Grid } from '@mui/material';
import { AnimatedCheck } from 'components';

const RespostaRegistrada: React.FC = () => (
  <Box>
    <Grid container display="flex" justifyContent="center" alignItems="center">
      <Box sx={{ width: 'auto' }}>
        <AnimatedCheck>Resposta registrada com sucesso!</AnimatedCheck>
      </Box>
    </Grid>
  </Box>
);

export default RespostaRegistrada;
